import {CHOOSE_NO_PLAN, CHOOSE_PLAN} from 'action_types/commonActionTypes';
import helper from './actionHelper';

export const choosePlan = plan => helper.getAction(CHOOSE_PLAN, plan);

export const chooseNoPlan = plan => helper.getAction(CHOOSE_NO_PLAN, plan);
